/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMaintenanceReportCommandResult } from '../../models/create-maintenance-report-command-result';
import { ReportDailyTaskVm } from '../../models/report-daily-task-vm';

export interface ApiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Params {
      body?: {
'ProjectId'?: string;
'Notes'?: string;
'ReportDailyTasks'?: Array<ReportDailyTaskVm>;
'Attachments'?: Array<Blob>;
}
}

export function apiProjectMaintenanceReportCreateProjectMaintenanceReportPost(http: HttpClient, rootUrl: string, params?: ApiProjectMaintenanceReportCreateProjectMaintenanceReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateMaintenanceReportCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectMaintenanceReportCreateProjectMaintenanceReportPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateMaintenanceReportCommandResult>;
    })
  );
}

apiProjectMaintenanceReportCreateProjectMaintenanceReportPost.PATH = '/api/ProjectMaintenanceReport/CreateProjectMaintenanceReport';
